import axios from "axios";

const rawApiUrl = (import.meta.env.VITE_API_URL as string | undefined) || "";
// VITE_API_URL points to the backend origin (e.g. http://localhost:25001).
// All business endpoints are mounted under /api/v1, so append it unless already present.
export const API_BASE_URL =
  rawApiUrl && !rawApiUrl.endsWith("/api/v1")
    ? `${rawApiUrl.replace(/\/$/, "")}/api/v1`
    : rawApiUrl || "/api/v1";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Tell the backend the browser-facing frontend origin. This is needed when
  // the frontend and backend are served through a reverse proxy / dev server
  // on the same origin, because the browser does not send an Origin header for
  // same-origin GET requests, but the backend still needs to know the public
  // URL to build OIDC redirect URIs.
  if (typeof window !== "undefined") {
    config.headers["X-Frontend-Origin"] = window.location.origin;
  }
  // Development helper: simulate a specific role for RLS/permission testing
  const devRole = localStorage.getItem("dev_role");
  if (devRole) {
    config.headers["X-User-Role"] = devRole;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);
